export default __webpack_public_path__ + "static/media/06.76897360.svg";